









import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter, Action, Mutation, State } from 'vuex-class';
import { TableModuleState } from '../store/modules/table/types';
const namespace = 'table';

@Component
export default class TableMeta extends Vue {
  @Getter private currentTable!: string;
  @State(namespace) private table!: TableModuleState;
  @Action('getMeta', { namespace }) private getMeta: any;
  @Action('updateTable', { namespace }) private updateTable: any;
  @Mutation('setTableMeta', { namespace }) private setTableMeta: any;
  @Watch('currentTable')
  private expandAll() {
    setTimeout(() => {
      if (this.$refs.editorInstance) {
        const { editor }: any = this.$refs.editorInstance;
        editor.expandAll();
      }
    }, 100);
  }
  private mounted() {
    this.expandAll();
  }
}
